import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeFromDateString',
  pure: false,
  standalone: false,
})
export class TimeFromDateStringPipe implements PipeTransform {
  transform(date: string): any {
    const dateObj = new Date(date);
    return dateObj.toLocaleTimeString('en-US');
  }
}
